<template>
  <div id="page-categories-list">

    <!-- BREADCRUMB SECTION -->
    <vs-row class="mb-5" vs-align="center">
      <vs-col vs-w="6">
        <h2 class="breadcrumb">Κατηγορίες</h2>
      </vs-col>
      <vs-col vs-w="6">
        <vs-button @click="openPopUpToCreateOrEdit" color="primary" type="filled" icon="add" class="ml-auto mb-2">
          Προσθήκη
        </vs-button>
      </vs-col>
    </vs-row>

    <!-- START: ADD NEW POPUP -->
    <div>
      <validation-observer v-slot="{invalid}">
        <form>
          <vs-popup class="holamundo" :title="displayPopUpTitle" :active="displayPopUp" @close="closePopUp">
            <validation-provider rules="required" v-slot="{errors}">
              <div class="vx-row mb-6">

                <div class="vx-col sm:w-1/3 w-full">
                  <span>Όνομα</span><span>*</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                  <vs-input class="w-full" v-model="name"/>
                </div>
              </div>
              <div class="text-right">
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </validation-provider>

            <div style="display:none;" class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Σειρά</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input type="number" class="w-full" v-model="order"/>
              </div>
            </div>

            <div style="display:none;" class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Χρώμα</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input type="color" class="w-full" name="" value="" v-model="color"/>
              </div>

            </div>
            <!--  <div class="vx-row" v-if="!validateForm()" >
                  <vs-alert class="mt-5" >Παρακαλώ συμπληρώστε όλα τα πεδία με *.</vs-alert>
              </div>-->
            <div class="vx-row">
              <div class="vx-col w-full text-right">
                <vs-button :disabled="invalid" class="mb-2 text-right" @click.prevent="addRecord">
                  Αποθήκευση
                </vs-button>
              </div>
            </div>
          </vs-popup>
        </form>
      </validation-observer>
    </div>
    <!-- END: ADD NEW POPUP -->

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
                class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{
                  currentPage * paginationPageSize - (paginationPageSize - 1)
                }} - {{
                  recordsData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : recordsData.length
                }} of {{ recordsData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery"
                  @input="updateSearchQuery" placeholder="Αναζήτηση..."/>
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue ref="agGridTable" :components="components" :gridOptions="gridOptions"
                   class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                   :defaultColDef="defaultColDef"
                   :rowData="recordsData" rowSelection="multiple" colResizeDefault="shift" :animateRows="true"
                   :floatingFilter="true" :pagination="true" :paginationPageSize="paginationPageSize"
                   :suppressPaginationPanel="true" :enableRtl="$vs.rtl" :paginationAutoPageSize="true" :filter="true"
                   @rowDoubleClicked="editItem"

                   :resizable="true">
      </ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage"/>

    </div>
  </div>

</template>

<script>
import {AgGridVue} from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

// Cell Renderer
import CellRendererLink from './cell-renderer-categories/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer-categories/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer-categories/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer-categories/CellRendererActions.vue'

// Validation
import {ValidationObserver, ValidationProvider, extend} from 'vee-validate'
import {required} from 'vee-validate/dist/rules'

extend('required', {
  ...required,
  message: 'Υποχρεωτικό πεδίο',
})

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,

    // Validation
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      initiated: false,
      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {
        floatingFilter: true,
        filter: true,
        pagination: true,
        pivotPanelShow: 'always',
        colResizeDefault: 'shift',
        animateRows: true,
        resizable: true,
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      columnDefs: [
        // {
        //   headerName: 'ID',
        //   field: 'id',
        //   width: 125,
        //   filter: true,
        //   checkboxSelection: true,
        //   headerCheckboxSelectionFilteredOnly: true,
        //   headerCheckboxSelection: true,
        //   suppressNavigable: true,
        //   cellClass: 'no-border',
        // },
        {
          headerName: 'Όνομα',
          field: 'name',
          filter: 'agTextColumnFilter',
          flex: 1,
          cellRendererFramework: 'CellRendererLink',
          suppressNavigable: true,
          cellClass: 'no-border',
        },
        // {
        //   headerName: 'Σειρά',
        //   field: 'order',
        //   filter: 'agTextColumnFilter',
        //   width: 100,
        //   suppressNavigable: true,
        //   cellClass: 'no-border',
        // },
        // {
        //     headerName: 'Χρώμα',
        //     field: 'color',
        //     filter: 'agTextColumnFilter',
        //     width: 200,
        //     cellRendererFramework: 'CellRendererStatus',
        //     suppressNavigable: true,
        //     cellClass: 'no-border'
        // },
        {
          headerName: '',
          field: 'id',
          width: 80,
          filter: false,
          cellRendererFramework: 'CellRendererActions',
          pinned: 'right',
          suppressNavigable: true,
          cellClass: 'no-border',
        },
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions,
      },
    }
  },
  watch: {},
  computed: {
    // Setting Categories
    recordsData() {
      return this.$store.getters.getSettingCategories
    },
    // Setting Category
    item() {
      return this.$store.getters.getSettingCategory
    },
    // Display categories popup
    displayPopUp() {
      return this.$store.getters.getDisplayCategoryPopUp
    },
    // Display Pop Up Title
    displayPopUpTitle() {
      return this.$store.getters.getCategoryPopUpTitle
    },
    // Getter and setter for category name
    name: {
      get() {
        return this.$store.getters.getSettingCategory.name
      },
      set(value) {
        this.$store.dispatch('setSettingCategoryName', value)
      },
    },
    // Getter and setter for category order
    order: {
      get() {
        return this.$store.getters.getSettingCategory.order
      },
      set(value) {
        this.$store.dispatch('setSettingCategoryOrder', value)
      },
    },
    // Getter and setter for category color
    color: {
      get() {
        return this.$store.getters.getSettingCategory.color
      },
      set(value) {
        this.$store.dispatch('setSettingCategoryColor', value)
      },
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      },
    },
    message: {
      get() {
        return this.$store.state.obj.message
      },
      set(value) {
        this.$store.commit('updateMessage', value)
      },
    },
  },
  methods: {
    editItem(value) {
      let item = value.data;
      this.$store.dispatch('setSettingCategoryItem', item)
      this.$store.dispatch('setCategoryPopUpTitle', `Επεξεργασία κατηγορίας ${item.name}`)
      this.$store.dispatch('setCategoryPopUpStatus', true)
    },
    openPopUpToCreateOrEdit() {
      this.$store.dispatch('setCategoryPopUpStatus', true)
      this.$store.dispatch('setCategoryPopUpTitle', 'Νέα Εγγραφή')
      const payload = {name: '', order: '', color: ''}
      this.$store.dispatch('setSettingCategoryItem', payload)
    },
    closePopUp() {
      this.$store.dispatch('setCategoryPopUpStatus', false)
      this.$store.dispatch('setCategoryPopUpTitle', '')
      const payload = {name: '', order: '', color: ''}
      this.$store.dispatch('setSettingCategoryItem', payload)
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = {type: 'equals', filter: val}
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter =
          this.statusFilter =
              this.isVerifiedFilter =
                  this.departmentFilter =
                      {
                        label: 'All',
                        value: 'all',
                      }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    },
    addRecord() {
      // Update if item.id exists
      if (this.item.id) {
        this.$store
            .dispatch('updateSettingCategory', this.item)
            .then(() => {
              this.closePopUp()
              this.$vs.notify({
                color: 'success',
                title: 'Επιτυχία',
                position: 'top-right',
                text: 'Οι αλλαγές σας αποθηκεύτηκαν.',
              })
            })
            .catch((err) => {
              this.$vs.notify({
                color: 'danger',
                title: 'Σφάλμα',
                position: 'top-right',
                text: 'Υπήρξε κάποιο πρόβλημα και τα δεδομένα δεν αποθηκεύτηκαν.',
              })
            })
      } else {
        this.$store
            .dispatch('addSettingCategory', this.item)
            .then(() => {
              this.closePopUp()
              this.$vs.notify({
                color: 'success',
                title: 'Επιτυχία',
                position: 'top-right',
                text: 'Οι αλλαγές σας αποθηκεύτηκαν.',
              })
            })
            .catch((err) => {
              this.$vs.notify({
                color: 'danger',
                title: 'Σφάλμα',
                position: 'top-right',
                text: 'Υπήρξε κάποιο πρόβλημα και τα δεδομένα δεν αποθηκεύτηκαν.',
              })
            })
      }
    },
    editRecord(item) {
      let vm = this
      vm.popupActive = true
      vm.item = item
      vm.modalTitle = 'Ενημέρωση Εγγραφής'
    },
  },
  mounted() {
    this.gridApi = this.gridOptions.api
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
          '.ag-header-container'
      )
      header.style.left = `-${String(
          Number(header.style.transform.slice(11, -3)) + 9
      )}px`
    }
  },
  created() {
    this.$store.dispatch('fetchSettingCategories')
  },
}
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

.ag-cell-focus,
.ag-cell-no-focus {
  border: none !important;
}

/* This CSS is to not apply the border for the column having 'no-border' class */
.no-border.ag-cell:focus {
  border: none !important;
  outline: none;
}
</style>
